import React from "react";

import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Alert
} from "reactstrap";
import "../../../styles/estilos.css";
import { withRouter } from "react-router-dom";
import { Textbox} from "react-inputs-validation";
import { connect } from "react-redux";
import { urlGuardarPasoHogar } from '../../../constants/urls'
import { FetchPost } from '../../../redux/actions/api'
import { expresionesRegulares } from "../../../constants";

class ValoresCotizacionResponsabilidad extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      height: window.innerHeight,
      claseDivFix: "flex-row div-flotante",
      correo: "",
      hasCorreoError:true,
      validarCorreo:false
    }
    this.handleScroll = this.handleScroll.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.onClickEnviarPDF = this.onClickEnviarPDF.bind(this);
    this.onActualizar = this.onActualizar.bind(this);
    this.onSiguiente = this.onSiguiente.bind(this);

  }

  onDismiss() {
    this.setState({ visibleAlert: false });
  }

  toggleValidating = (validate) => {
    this.setState({ validate });
  }

   onClickEnviarPDF(e) {
    this.toggleValidating(true)
    const { correo,hasCorreoError } = this.state;
    this.setState({validarCorreo:false})
    if(!hasCorreoError){
        this.props.metodoEnviar({ correo: correo, idCarrito:this.props.detalleCarrito.ultimoPaso.resultado.idCarrito});
        if(this.props.datosEnviarPDFFinanciero.respuestaCorreo)
          this.setState({validarCorreo:true})
    }
  }

  // onSiguiente(e) {
  //   const {detalleCarrito} = this.props;
  //   this.props.history.push({
  //     pathname: "/datos-facturacion",
  //     search: `?id=${detalleCarrito.ultimoPaso.resultado.idCarrito}`

  //   });
  // }
  async onSiguiente(e) {
    const {detalleCarrito} = this.props;
    let resp = await FetchPost({
      url: urlGuardarPasoHogar, param: {
        empresa:"AIGMETROPOLITANA",
        plataforma:"WEB",
        idcarrito:detalleCarrito.idCarrito,
        numeroPaso:"3"        
      }})
    const { transaccion } = resp
    if (transaccion) {
      this.props.history.push({
        pathname: "/datos-facturacion",
        search: `?id=${detalleCarrito.idCarrito}`
      });
    }    
  }

  onActualizar(e) {
    const {formActualizar} = this.props;
    const {formEditado} = formActualizar;

    if(formEditado){
        this.props.metodoActualizarValores({formEditado:false});
    }
  }
  
  /* Eventos Scroll */
  handleScroll() {
    const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    const windowBottom = windowHeight + window.pageYOffset;
    if (this.props.paso === "resumen-cotizacion") {
      console.log("docHeight",docHeight)
        if (windowBottom >= (docHeight -5)) {
          this.setState({
            claseDivFix: 'flex-row div-flotante fix-botton-totales-resumen'
          });
        } else {
          this.setState({
            claseDivFix: 'flex-row div-flotante'
          });
        }
    }
    else {
      if (windowBottom >= (docHeight - 120)) {
        this.setState({
          claseDivFix: 'flex-row div-flotante fix-botton-totales'
        });
      } else {
        this.setState({
          claseDivFix: 'flex-row div-flotante'
        });
      }
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    const {claseDivFix,correo,validarCorreo,validate} = this.state;
    const {formActualizar,detalleCarrito} = this.props;
    const {formEditado,desabilitarBotonContinuar} = formActualizar;
    //const valorTotal = this.props.detalleCarrito.valorTotal;

    //Validaciones de texto de boton
    let textoBoton = " INICIAR EMISIÓN";
    let claseBoton = "btn btn-primary";
    if(formEditado)
    {
      textoBoton = "ACTUALIZAR";
      claseBoton = "btn btn-primary btn-purple fe-pulse";
    }    


    let valorTotal = {
      primaNeta: "0.00",
      primaTotal: "0.00",
      impuestos : [{nombre:"Superintendencia 3.5%", valor:"0.0"},
                    {nombre:"Seguro Campesino 0.5%", valor:"0.0"},
                    {nombre:"Derechos de emisión", valor:"0.0"},
                    {nombre:"IVA 15%", valor:"0.0"}],
      totalImpuestos: "0.00"
    }

    if(detalleCarrito.valorTotal) {                 
      valorTotal = {
        primaNeta: detalleCarrito.valorTotal.primaNeta,
        impuestos: detalleCarrito.valorTotal.impuestos,
        primaTotal: detalleCarrito.valorTotal.primaTotal,
        totalImpuestos: detalleCarrito.valorTotal.totalImpuestos
      }
    }
    return (

      <Card className={claseDivFix}>
        <CardBody>
          <div>
          <h4 style={{ fontWeight: "bold" }}>Valor del Seguro</h4>
          <Row>
            <Col lg={6} md={6} sm={6} xs={6}>
              <h5>Prima Neta</h5>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6}>
              <h5>${valorTotal.primaNeta}</h5>
            </Col>
          </Row>
          <Row>
            <div id="container-imp">
              <div className="accordion-imp">
                <input type="checkbox" id="tm" />
                <label htmlFor="tm" className="accordionitem">
                  <Row>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5 title={"Presiona click para ver/ocultar el detalle impuestos"} >
                        Impuestos{" "}
                        <i
                          className="fa fa-info-circle"
                          aria-hidden="true"
                        />
                      </h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>${valorTotal.totalImpuestos}</h5>
                    </Col>
                  </Row>
                </label>
                <div className="hiddentext ocultar">
                {valorTotal.impuestos !== undefined && 
                      valorTotal.impuestos.map((impuesto, i) => {
                        return (
                          <Row key={'item:' + i} >
                            <Col lg={6} md={6} sm={6} xs={6}>
                              <h5>{impuesto.nombre}</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={6}>
                              <h5>${impuesto.valor}</h5>
                            </Col>
                          </Row>
                        );      
                      })
                    }  
                </div>
              </div>
            </div>
          </Row>
          <Row>
            <Col lg={6} md={6} sm={6} xs={6}>
              <p />
              <h5 style={{ fontWeight: "bold" }}>Prima Total</h5>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6}>
              <p />
              <h5 style={{ fontWeight: "bold" }}>${valorTotal.primaTotal}</h5>
            </Col>
          </Row>
          <hr />
          <Row className="mb-3">
            <Col lg={12} md={12} sm={12} xs={12}>
                <Button
                    className={claseBoton}
                    onClick={formEditado ? this.onActualizar : this.onSiguiente  }
                    //onClick={this.onActualizar}
                    style={{ display: "block", margin: "auto" }}
                    disabled={desabilitarBotonContinuar}
                >
                <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                {textoBoton}
                </Button>
            </Col>
          </Row>
          {this.props.detalleCarrito.carUrlPdf && 
          <div>
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                <a className="btn btn-detail-white" href= {this.props.detalleCarrito.carUrlPdf}
                  target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-cloud-download" aria-hidden="true" /> DESCARGAR COTIZACIÓN
                </a>
                <br></br>
              </Col>
            </Row>
            {this.props.paso === "resumen-cotizacion" && 
            this.props.dataUsuario.usu_tipo_usuario !== "cliente"  &&
              <Row>
                <Col lg={8} md={8} sm={12} xs={12}>
                  <Textbox
                    tabIndex="1"
                    type="text"
                    value={correo}
                    name="correo"
                    id="correo"
                    placeholder="Por favor ingrese un correo valido"
                    classNameInput={"form-control"}
                    validate={validate}
                    onChange={(correo, e) => {
                      this.setState({ correo: correo});
                    }}
                    onBlur={() => {this.setState({validarCorreo:false});}} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                    validationCallback={res => this.setState({ hasCorreoError: res, validate:false })}// Optional.[Func].Default: none. Return the validation result.
                    validationOption={{
                      name: "correo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                      check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                      reg: expresionesRegulares.email,
                      required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                      msgOnError: "Por favor ingrese un correo electronico válido" // Optional.[Bool].Default: true. To determin if it is a required field.
                    }}
                  />
                </Col>
                <Col lg={4} md={4} sm={12} xs={12}>
                  <Button className="btn btn-detail-white" 
                    onClick={this.onClickEnviarPDF}>
                    <i className="fa fa-trash-o" aria-hidden="true" /> ENVIAR
                </Button>
                </Col > 
                {validarCorreo &&
                  <Alert color="success" isOpen={this.state.visibleAlert} toggle={this.onDismiss}>
                    <center><p>Se ha enviado correctamente la cotización al correo electrónico ingresado.</p></center>
                  </Alert>
                } 
              </Row>
            }
          </div>
          }
          </div>
        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  dataUsuario: state.datosUsuarios.dataUsuario,
  datosEnviarPDFFinanciero: state.datosEnviarPDFFinanciero,
});

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ValoresCotizacionResponsabilidad)
);
